import { reviewsFormat } from '@/pages/opinion/utils/value';
import React from 'react';
import { StatusTip, Table } from 'tea-component';
import { useIntl } from 'umi';

const { scrollable } = Table.addons;
export default function TotalTable({
  originalData,
}: {
  originalData: Array<any>;
}) {
  const { formatMessage } = useIntl();

  return (
    <div>
      <Table
        verticalTop
        records={originalData}
        recordKey="date"
        columns={[
          {
            key: 'date',
            header: formatMessage({ id: 'Date' }),
          },
          {
            key: 'today',
            header: formatMessage({ id: 'Search index(Today)' }),
            align: 'right',
            render: ({ today }) => reviewsFormat(today),
          },
          {
            key: 'lastWeek',
            header: formatMessage({ id: 'Search index(Last Day)' }),
            align: 'right',
            render: ({ lastWeek }) => reviewsFormat(lastWeek),
          },
        ]}
        topTip={
          originalData.length === 0 && (
            <StatusTip
              style={{ height: 230, lineHeight: '230px' }}
              status="empty"
            />
          )
        }
        addons={[
          scrollable({
            maxHeight: 262,
          }),
        ]}
      />
    </div>
  );
}
